import React from 'react'
import Box from '../primitives/Box'
import { YoutubeVideo } from '../../components/YoutubeVideo'

export function RegistrationFormSection() {
  const videoId = 'IBGG4umzRbI'

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems="flex-start"
      gap={{ xs: 16, md: 48, lg: 64 }}
      css={{ margin: '0 auto', maxWidth: '1280px', padding: '0 16px' }}
    >
      {/* Left column: heading + description */}
      <Box
        css={`
          width: 100%;
          padding: 0 32px;
          @media screen and (min-width: 981px) {
            flex: 0 0 40%;
            max-width: 40%;
          }
        `}
      >
        <Box.h2 font="h2">What’s new in Swarmia [April 2025]</Box.h2>
        <Box font="medium" marginTop={{ xs: 32, sm: 32 }}>
          In this live session from April 24, 2025 Swarmia Founder & CEO Otto
          Hilska and Head of Product & Design Roman Musatkin share our latest
          feature updates and a preview into what we’re building.
          <br />
          <br />
          <ul>
            <li>Swarmia product vision by Otto Hilska</li>
            <li>Latest releases & roadmap for 2025 by Roman Musatkin </li>
          </ul>
          <br />
        </Box>
      </Box>

      {/* Right column: responsive YouTube embed */}
      <Box
        css={`
          width: 100%;
          padding: 0 32px;
          margin-top: 32px;
          @media screen and (min-width: 981px) {
            flex: 0 0 60%;
            max-width: 60%;
            margin-top: 0;
          }
        `}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%', // 16:9 aspect ratio
            height: 0,
          }}
        >
          <YoutubeVideo videoId={videoId} />
        </div>
      </Box>
    </Box>
  )
}
